<template>
  <v-container>
    <v-row no-gutters class="vehicle-title">
      {{ $t('device.list.item.vehicle') }}
      <span v-if="device.devicePersonalisationState.inProgress" :id="`vehicle-block-${device.id}-inprogress`" class="in-progress">
        <img :src="require(`@/assets/images/custom-vehicle-inprogress.svg`)" alt="vehicle-inprogress">
        <span>{{ $t('device.list.item.change_progress') }}</span>
      </span>
    </v-row>
    <v-row class="vehicle-wrapper" no-gutters>
      <v-col>
        <v-row>
          <v-col class="toll-domain">
            <v-row>
              <v-col class="col-auto toll-domain-title py-0">
                {{ $t('map.tolldomains.legends.config_name') }}
              </v-col>
              <v-col v-if="device.devicePersonalisationState && device.devicePersonalisationState.currentPersonalisation" class="py-0">
                <div class="toll-domain-container py-0">
                  <v-chip
                    id="vehicle-perso-variant"
                    dark
                    small
                    :class="`toll-domains-type-${device.devicePersonalisationState.currentPersonalisation.variant.isDefault ? 'default' : 'official'}`"
                  >
                    {{ device.devicePersonalisationState.currentPersonalisation.variant.name }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="toll-domain scrollable">
            <v-row>
              <v-col class="col-auto toll-domain-title py-0">
                {{ $t('map.tolldomains.legends.toll_domain') }}
              </v-col>
              <v-col v-if="device.devicePersonalisationState.subscriptions.length > 0" class="py-0 pl-0">
                <div class="toll-domain-container">
                  <span
                    v-for="domain in getTolldomainNames(device.devicePersonalisationState.subscriptions)"
                    :id="`vehicle-${device.id}-tollzone-${domain.name}`"
                    :key="domain.name"
                    class="vehicle-value vehicle-tolldomain"
                    :class="`${tolldomainTypes[domain.type]}`"
                    :title="domain.type"
                  >
                    {{ domain.name }}
                  </span>
                </div>
              </v-col>
              <v-col v-else-if="getDevicesListState.loading.tollDomainNames" class="py-0">
                <Loaders type="label" />
              </v-col>
              <v-col v-else class="py-0">
                <div class="toll-domain-container">
                  <span class="vehicle-value vehicle-tolldomain">
                    {{ $t('common.no_data') }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="my-0">
            <div>
              <span :id="`vehicle-${device.id}-seemore`" class="see-more" @click="$emit('seeMore')">
                {{ $t('common.see_more') }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import Utils from '@/mixins/Utils';
import { colors } from '@/constants/theme/colors';
import { IDevicesListState, store } from '@/store/modules/devices/types';
import Loaders from '@/components/common/Loaders/Loaders.vue';
import { TOLLDOMAIN_TYPES } from '@/constants/components/tolldomains';

@Component({
  components: {
    Loaders
  }
})
export default class VehicleBloc extends Mixins(Utils) {
  @Prop()
  private device: any;

  private colors = colors;

  private tolldomainTypes = TOLLDOMAIN_TYPES;

  @store.Getter
  private getDevicesListState!: IDevicesListState;

  getTolldomainNames(domains: any) {
    return domains.map((domain: string) => ({
      name: domain.replace(/^:?([^:]*):?$/, (match: string, middle: string) => `${match.startsWith(':') ? 'Default' : middle}:${match.endsWith(':') ? 'Default' : middle}`),
      type: domain === ':' ? 0 : 2
    }));
  }
}

</script>
<style lang="scss" scoped>
@import './styles/vehicle-bloc.scss';
</style>
